/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Duration
 */
export interface Duration {
    /**
     * 
     * @type {number}
     * @memberof Duration
     */
    value: number;
    /**
     * 
     * @type {string}
     * @memberof Duration
     */
    unit: DurationUnitEnum;
    /**
     * 
     * @type {boolean}
     * @memberof Duration
     */
    fixed: boolean;
}


/**
 * @export
 */
export const DurationUnitEnum = {
    Days: 'DAYS',
    Weeks: 'WEEKS',
    Months: 'MONTHS'
} as const;
export type DurationUnitEnum = typeof DurationUnitEnum[keyof typeof DurationUnitEnum];


/**
 * Check if a given object implements the Duration interface.
 */
export function instanceOfDuration(value: object): value is Duration {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('unit' in value) || value['unit'] === undefined) return false;
    if (!('fixed' in value) || value['fixed'] === undefined) return false;
    return true;
}

export function DurationFromJSON(json: any): Duration {
    return DurationFromJSONTyped(json, false);
}

export function DurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Duration {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
        'unit': json['unit'],
        'fixed': json['fixed'],
    };
}

export function DurationToJSON(value?: Duration | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'value': value['value'],
        'unit': value['unit'],
        'fixed': value['fixed'],
    };
}

